import styles from './Backend.module.scss'
import LpIntroduction from './LpIntroduction'
import Features from './Features'
import Performance from './Performance'
import Architecture from './Architecture'
import ProjectFlow from './ProjectFlow'
import FAQ from './FAQ'
import Contact from './Contact'
import LinkCard from './LinkCard'

const Frontend: React.FC = () => {
  return (
    <article className={styles.LPPage} id="backendLP">
      <LpIntroduction />
      <div className={styles.contents}>
        <Features />
        <Performance />
        <Architecture />
        <ProjectFlow />
        <FAQ />
        <LinkCard />
        <Contact />
      </div>
    </article>
  )
}

export default Frontend
